<template>
  <page>
    <lazy-div :load="doInit">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-toolbar-title>{{
            this.selectedRi.polNo + ' ' + this.selectedRi.renCnt + ' ' + this.selectedRi.endtCnt + ' - ' + this.selectedRi.insdName1
          }}</v-toolbar-title>
        </v-toolbar>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-toolbar-title>{{
            'Cession Endt: ' +
            (this.selectedRi.cesEndtCnt === undefined ? '-' : this.selectedRi.cesEndtCnt) +
            ' - ' +
            (this.selectedRi.acctNoSfx === undefined ? '-' : this.selectedRi.acctNoSfx) +
            ' - ' +
            (this.selectedRi.riCo === undefined ? '-' : this.selectedRi.riCo) +
            ' - ' +
            (this.selectedRi.riCoName === undefined ? '-' : this.selectedRi.riCoName)
          }}</v-toolbar-title>
        </v-toolbar>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-divider></v-divider>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <form data-vv-scope="riForm">
              <v-layout row wrap>
                <v-flex xs6 v-if="reviewMode">
                  <cal-picker
                    v-model="riForm.ccaDate"
                    :label="labels.ccaDate"
                    :data-vv-as="labels.ccaDate"
                    data-vv-name="ccaDate"
                    :error-messages="errors.collect('riForm.ccaDate')"
                    v-validate="valContrctCertDate"
                  ></cal-picker>
                </v-flex>
                <v-flex xs6 v-else>
                  <v-subheader class="queryLabel">{{ labels.ccaDate }}</v-subheader>
                  <div class="queryValue">{{ formatDisplayDate(riForm.ccaDate) }}</div>
                </v-flex>
                <v-flex xs6 v-if="reviewMode">
                  <cal-picker
                    v-model="riForm.ccdDate"
                    :label="labels.ccdDate"
                    :data-vv-as="labels.ccdDate"
                    data-vv-name="ccdDate"
                    :error-messages="errors.collect('riForm.ccdDate')"
                    v-validate="valContrctDocDate"
                  ></cal-picker>
                </v-flex>
                <v-flex xs6 v-else>
                  <v-subheader class="queryLabel">{{ labels.ccdDate }}</v-subheader>
                  <div class="queryValue">{{ formatDisplayDate(riForm.ccdDate) }}</div>
                </v-flex>
                <v-flex xs6 v-if="reviewMode">
                  <v-text-field
                    v-model="riForm.theirPolNo"
                    :label="labels.theirPolNo"
                    :data-vv-as="labels.theirPolNo"
                    data-vv-name="theirPolNo"
                    :error-messages="errors.collect('riForm.theirPolNo')"
                    v-validate="'max:30'"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 v-else>
                  <v-subheader class="queryLabel">{{ labels.theirPolNo }}</v-subheader>
                  <div class="queryValue">{{ riForm.theirPolNo }}</div>
                </v-flex>
              </v-layout>
            </form>
          </v-container>
          <v-spacer class="mt-3"></v-spacer>
          <v-layout>
            <v-btn color="red darken-1" dark class=" mr-2" @click.native="doExit">
              Exit
              <v-icon right dark>mdi-exit-to-app</v-icon>
            </v-btn>
            <v-btn v-if="!queryMode" color="grey darken-1" dark class=" mr-2" @click.native="doReset">
              Reset
              <v-icon right dark>mdi-refresh</v-icon>
            </v-btn>
            <v-btn v-if="!queryMode" color="primary" dark class=" mr-2" @click="doSave" :loading="submitting">
              Save
              <v-icon right>mdi-content-save</v-icon>
            </v-btn>
          </v-layout>
        </v-card-text>
      </v-card>

      <v-container fluid grid-list-sm>
        <v-layout row wrap>
          <v-flex lg12 xs12 order-lg1 order-xs2>
            <common-comments :commentRefNo="this.commentRefNo" :commentTranType="this.commentTranType" :mode="this.commentMode"></common-comments>
          </v-flex>
        </v-layout>
      </v-container>

      <v-dialog v-model="processingFlag" persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Processing...
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>

      <warning v-model="promptCommentDialog"> {{ warningMsg }}</warning>
    </lazy-div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import CommonComments from '@/components/core/accounting/CommonComments'
import { expandURI } from '@/utils/ajax'
import { riAjaxMixin } from '@/mixins/reinsurance/riAjaxMixin'
import { parseISO } from 'date-fns'

export default {
  data() {
    return {
      disabled: true,
      toogleArray: [false],
      submitting: false,
      newMode: false,
      reviewMode: false,
      queryMode: false,
      labels: {
        ccaDate: 'Contract Certainty Acceptance Date',
        ccdDate: 'Contract Certainty Documentation Date',
        theirPolNo: 'Their Policy No.'
      },
      riForm: {
        ccaDate: null,
        ccdDate: null,
        theirPolNo: null,
        verCnt: 0
      },
      processingFlag: false,
      loading: true,
      today: new Date(),
      showVoidConfirmation: false,
      promptCommentDialog: false,
      warningMsg: '',
      commentMode: ''
    }
  },
  computed: {
    mode() {
      return this.$route.params.mode
    },
    commentURL() {
      return this.$store.state.commonComments.menu
    },
    commentRefNo() {
      return (
        this.selectedRi.polNo +
        this.selectedRi.renCnt +
        this.selectedRi.cesEndtCnt +
        this.selectedRi.riType +
        this.selectedRi.riCo +
        this.selectedRi.acctNoSfx +
        this.selectedRi.endtCnt +
        this.riForm.verCnt
      )
    },
    commentTranType() {
      return this.selectedRi.tranType
    },
    valContrctCertDate() {
      var date
      var dateName
      if (this.riForm.ccaDate !== null && this.riForm.ccaDate !== undefined) {
        if (this.selectedRi.riComDate != null && this.selectedRi.riComDate !== undefined) {
          date = this.selectedRi.riComDate
          dateName = 'Commencement Date'
        } else if (this.selectedRi.riTranDate != null && this.selectedRi.riTranDate !== undefined) {
          date = this.selectedRi.riTranDate
          dateName = 'Transaction Date'
        }
        var diffInTime = this.riForm.ccaDate - parseISO(date)
        var diffInDay = diffInTime / (1000 * 3600 * 24) + 1
        return 'entry|valCcaDate:' + diffInDay + ',' + dateName
      }
      return ''
    },
    valContrctDocDate() {
      var date
      var dateName
      if (this.riForm.ccdDate !== null && this.riForm.ccdDate !== undefined) {
        if (this.selectedRi.riComDate != null && this.selectedRi.riComDate !== undefined) {
          date = this.selectedRi.riComDate
          dateName = 'Commencement Date'
        } else if (this.selectedRi.tranDate != null && this.selectedRi.tranDate !== undefined) {
          date = this.selectedRi.tranDate
          dateName = 'Transaction Date'
        }
        var diffInTime = this.riForm.ccdDate - parseISO(date)
        var diffInDay = diffInTime / (1000 * 3600 * 24) + 1
        return 'entry|valCcdDate:' + diffInDay + ',' + dateName
      }
      return ''
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('riOutInit')])
      await this.$store.dispatch('riOutListingInit')
      this.doReset()
      this.getRiOutAmdtMaxVerCnt()
    },
    doExit() {
      this.$router.push({ name: 'riOutwardList' })
    },
    async doReset() {
      this.riForm.ccaDate = this.selectedRi.ccaDate
      this.riForm.ccdDate = this.selectedRi.ccdDate
      this.riForm.theirPolNo = this.selectedRi.theirPolNo
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll('riForm').then((result) => {
        if (result) {
          this.checkComment()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async getRiOutAmdtMaxVerCnt() {
      const apiUrl = this.$store.state.reinsurance.riOutListing.menu.getMaxRiOutAmdtVerCnt
      const requestParams = {
        polNo: this.selectedRi.polNo,
        renCnt: this.selectedRi.renCnt,
        cesEndtCnt: this.selectedRi.cesEndtCnt,
        riType: this.selectedRi.riType,
        riCo: this.selectedRi.riCo,
        acctNoSfx: this.selectedRi.acctNoSfx,
        endtCnt: this.selectedRi.endtCnt
      }
      if (apiUrl) {
        this.loading = true
        try {
          const result = await this.$http.get(expandURI(apiUrl, requestParams))
          const { data } = result.data
          if (data) {
            this.riForm.verCnt = parseInt(data.riOutAmdtDetail.verCnt) + 1
          } else {
            this.riForm.verCnt = 1
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      }
    },
    async checkComment() {
      const apiUrl = this.commentURL.isExistComment
      if (apiUrl) {
        try {
          const expand = {
            commentRefNo: this.commentRefNo
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result.data
          if (data === true) {
            this.createRiOutAmdt().then(() => {
              if (result) {
                this.$router.push({ name: 'riOutwardList' })
              }
            })
          } else {
            this.promptCommentDialog = true
            this.warningMsg = 'Must enter a reason for amendment at the Remarks session'
          }
        } catch (err) {
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    formatDisplayDate(xDate) {
      if (xDate === null) {
        return undefined
      } else {
        return formatDisplayDate(xDate)
      }
    }
  },
  created() {
    this.doInit()
    if (this.mode !== '') {
      if (this.mode === 'review') {
        this.reviewMode = true
      } else if (this.mode === 'query') {
        this.queryMode = true
        this.commentMode = 'query'
      }
    }
    this.$validator.extend('valCcaDate', {
      getMessage(field, args) {
        var dateName = args[1]
        return 'Contract Certainty Acceptance Date is 100 days earlier or later than ' + dateName + ' (10435)'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var totDays = args[0]
        if (totDays > 100) {
          return false
        } else {
          return true
        }
      }
    })
    this.$validator.extend('valCcdDate', {
      getMessage(field, args) {
        var dateName = args[1]
        return 'Contract Certainty Documentation Date is 100 days earlier or later than ' + dateName + ' (10435)'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var totDays = args[0]
        if (totDays > 100) {
          return false
        } else {
          return true
        }
      }
    })
  },
  mixins: [MessageMixin, riAjaxMixin],
  props: {
    selectedRi: {
      type: Object,
      default: null
    }
  },
  components: {
    CommonComments
  }
}
</script>
